import { useState, useCallback } from 'react'
import { useFilestack } from '@retailer-platform/shared-components'
import { type ImageUploaderProps, type FileError } from './ImageUploader.types'
import { validateImage, encodeFileName } from './ImageUploader.utils'

export const useImageUploader = ({
  value,
  onChange,
  filestackApiKey,
  requiredDimensions,
  path,
  requireEncodeFileName = false,
}: ImageUploaderProps) => {
  const { url, fileName, uploadFile, clearFile, uploading, uploadError } = useFilestack({
    value,
    filestackApiKey,
    onFileUpload: onChange,
  })
  const [fileError, setFileError] = useState<FileError>(null)

  const uploadImage = useCallback(
    (file: File) => {
      if (requireEncodeFileName) {
        file = encodeFileName(file)
      }
      validateImage(file, requiredDimensions)
        .then(() => {
          setFileError(null)
          uploadFile(file, undefined, undefined, path)
        })
        .catch(error => {
          setFileError(error)
        })
    },
    [requireEncodeFileName, requiredDimensions, uploadFile, path]
  )

  const clearImage = useCallback(() => {
    onChange?.(null, null, null)
    clearFile()
  }, [onChange, clearFile])

  return {
    url,
    fileName,
    uploadImage,
    clearImage,
    uploading,
    uploadError,
    fileError,
  }
}
